import React from "react";
import "./Loader.css";
import logo from "./img/logo.png";

const LogoLoader = () => {
  return (
    <div className="logo-loader-overlay">
     <div className="logo-loader-content">

  <div className="logo-center">
    <div className="logo-ring"></div>

    <div className="logo-wrap">
      <img src={logo} alt="Logo" className="logo-loader-img" />
    </div>
  </div>

  <p className="logo-loader-text">Завантаження...</p>
</div>
    </div>
  );
};

export default LogoLoader;